import React from 'react'
import map from 'lodash/map'

export class ToastErrors extends React.Component {
  render() {
    const { errors } = this.props
    if (!errors || !errors.length) return null

    return (
      <>
        {map(errors, error => (
          <div key={`id${error}`}>{error}</div>
        ))}
      </>
    )
  }
}

ToastErrors.defaultProps = {
  errors: [],
}

export default ToastErrors
